import * as React from 'react'
import { useLayoutEffect } from './use-isomorphic-layout-effect'

export interface ElementWithFullscreenFunctions extends HTMLDivElement {
  msRequestFullscreen?: () => void
  webkitRequestFullscreen?: () => void
}

type FullscreenStatus = {
  frameRefEl: React.RefObject<any>
  isFullScreen: boolean
  onFullScreenClick: () => void
}

// modified from https://stackoverflow.com/a/64485245
export function useFullscreen<ElementType extends ElementWithFullscreenFunctions>(): FullscreenStatus {
  const elRef = React.useRef<ElementType>(null)
  const [isFullScreen, setIsFullscreen] = React.useState<boolean>(false)

  useLayoutEffect(() => {
    document.onfullscreenchange = () => setIsFullscreen(document.fullscreenElement != null)

    return () => {
      document.onfullscreenchange = null
    }
  })

  const onFullScreenClick = () => {
    if (isFullScreen && typeof document !== 'undefined') {
      document.exitFullscreen()
    } else if (elRef.current) {
      if (elRef.current.requestFullscreen) {
        elRef.current.requestFullscreen()
      } else if (elRef.current.webkitRequestFullscreen) {
        elRef.current.webkitRequestFullscreen()
      } else if (elRef.current.msRequestFullscreen) {
        elRef.current.msRequestFullscreen()
      }
    }
  }

  return { frameRefEl: elRef, isFullScreen, onFullScreenClick }
}
